import { CtaSchema } from 'cms/schemaTypes/generalSchemas/cta'
import { SectionPageSchema } from 'cms/schemaTypes/staticPages/documents/section'

import { getCMSCtaLinkParams } from 'lib/sanity/links'
import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import LinkButton from 'shared/ui/Button/LinkButton'

import {
  PageTitle,
  SectionContainer,
  SectionContent
} from '../landings/styles'

import styles from './CooperationIntroSection.module.scss'

interface CooperationIntroSectionProps {
  introSection: SectionPageSchema
  cta: CtaSchema
}

const CooperationIntroSection = ({
  introSection,
  cta
}: CooperationIntroSectionProps) => {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={16} $bottomMobile={24}>
        <div className={styles.contentWrapper}>
          <PageTitle
            dangerouslySetInnerHTML={{ __html: introSection.header }}
          />
          <LinkButton
            className={styles.ctaButton}
            href={getCMSCtaLinkParams(cta).href}
            variant='tertiary'
            size='large'
          >
            {cta.text}
          </LinkButton>
          <CustomPortableText value={introSection.content || []} />
        </div>
      </SectionContent>
    </SectionContainer>
  )
}

export default CooperationIntroSection
